/**
 * @file
 * Gallery component category filters (paragraph--image-gallery--default
 * .html.twig, _gallery_filters.scss).
 *
 * One button per category the gallery's images are tagged with (their
 * Tags, in the vocabulary's order), plus one for all of them. Choosing one
 * hides the other photos ([hidden]) and leaves them out of the full-screen
 * viewer: PhotoSwipe collects the a.photoswipe links when it opens, so a
 * hidden photo's link loses that class until it's shown again. The count
 * shown is announced to screen readers.
 *
 * The buttons are rendered hidden and shown here, so without JavaScript
 * every photo simply shows.
 */
(function (Drupal, once) {

  'use strict';

  Drupal.behaviors.layeroneGalleryFilters = {
    attach: function (context) {
      once('gallery-filters', '[data-gallery-filters]', context).forEach(function (gallery) {
        const buttons = gallery.querySelectorAll('[data-gallery-filter]');
        const items = gallery.querySelectorAll('[data-gallery-categories]');
        const status = gallery.querySelector('[data-gallery-status]');
        if (!buttons.length || !items.length) {
          return;
        }

        function show(filter, label) {
          let count = 0;
          items.forEach(function (item) {
            const match = filter === 'all' || item.dataset.galleryCategories.split(' ').includes(filter);
            item.hidden = !match;
            item.querySelectorAll('a.photoswipe, a.photoswipe-filtered').forEach(function (link) {
              link.classList.toggle('photoswipe', match);
              link.classList.toggle('photoswipe-filtered', !match);
            });
            count += match ? 1 : 0;
          });
          buttons.forEach(function (button) {
            button.setAttribute('aria-pressed', button.dataset.galleryFilter === filter ? 'true' : 'false');
          });
          if (status) {
            status.textContent = filter === 'all'
              ? Drupal.formatPlural(count, 'Showing 1 photo.', 'Showing all @count photos.')
              : Drupal.formatPlural(count, 'Showing 1 photo of @category.', 'Showing @count photos of @category.', { '@category': label });
          }
        }

        buttons.forEach(function (button) {
          button.addEventListener('click', function () {
            show(button.dataset.galleryFilter, button.textContent.trim());
          });
        });
        gallery.querySelector('.gallery-filters').hidden = false;
      });
    },
  };

})(Drupal, once);
